function NightsafeScript() {
    document.addEventListener("DOMContentLoaded", function () {
        const nightsafeFormElement = document.querySelector('form[name="SubscriberForm"]')

        if (nightsafeFormElement) {

            nightsafeFormElement.onsubmit = function () {
                return CorrectEmailaddress(this);
            };

            function CorrectEmailaddress(SubscriberForm) {
                if (SubscriberForm.pf_Email.value.length > 255) {
                    alert("Please enter at most 255 characters in the \'Email address\' field.");
                    SubscriberForm.pf_Email.focus();
                    return false;
                }
                if (SubscriberForm.pf_Email.value == "") {
                    alert("Please enter a value for the \'Email address\' field.");
                    SubscriberForm.pf_Email.focus();
                    return false;
                }
                if (SubscriberForm.pf_Email.value.length < 7) {
                    alert("Please enter at least 7 characters in the \'Email address\' field.");
                    SubscriberForm.pf_Email.focus();
                    return false;
                }
                pf_Email = SubscriberForm.pf_Email.value;
                var reg = /^([a-zA-Z0-9_\-\.\+]*)([a-zA-Z0-9_\-])@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,10}|[0-9]{1,3})(\]?)$/;
                if (reg.test(pf_Email) == false) {
                    alert('Your email address is not valid. Please try again.');
                    SubscriberForm.pf_Email.focus();
                    return false;
                }
                var counter = 0;
                for (i = 1; i <= SubscriberForm.pf_CounterMailinglists.value; i++) {
                    var checkBoxName = "pf_MailinglistName" + i;
                    if (document.getElementsByName(checkBoxName)[0].checked || document.getElementsByName(checkBoxName)[0].type == "hidden") counter++;
                }
                if (counter == 0) {
                    alert("One or more mailing lists are required for this form.");
                    return false;
                }
                return true;
            }

            var recaptchaScript = document.createElement('script');
            recaptchaScript.src = "https://www.google.com/recaptcha/api.js?render=6Lc20eAZAAAAAGQsCu8tKqLu3O5AtdjUrVE9AZtr";
            recaptchaScript.async = true;
            document.head.appendChild(recaptchaScript);

            recaptchaScript.onload = function () {
                var input = document.createElement('input');
                input.setAttribute('type', 'hidden');
                input.setAttribute('name', 'g-recaptcha-token');
                input.setAttribute('id', 'g-recaptcha-token');
                nightsafeFormElement.appendChild(input);

                var refreshToken = function () {
                    grecaptcha.execute('6Lc20eAZAAAAAGQsCu8tKqLu3O5AtdjUrVE9AZtr', { action: 'subscription_from_submit' }).then(function (token) {
                        input.setAttribute('value', token);
                    });
                }

                grecaptcha.ready(function () {
                    refreshToken();
                    setInterval(function () { refreshToken(); }, 10000);
                });
            };

        }
    })
}

NightsafeScript();

export default NightsafeScript;
